export function updateOnboardingStatus(newStatus) {
  const user = JSON.parse(localStorage.getItem("user"));

  if (user) {
    user.onboarding_status = newStatus;
    localStorage.setItem("user", JSON.stringify(user));
  }
}
